import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetTableRow } from '../data-maintenance.model';

@Component({
  selector: 'app-file-name-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="file-name-cell">
      <i [class]="getFileIcon(rowData)"></i>
      <span class="file-name">{{ rowData?.fileName }}</span>
    </span>
  `,
  styles: [
    `
      .file-name-cell {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      i {
        font-size: 1.2rem;
        color: #666;
      }
      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileNameRendererComponent {
  @Input() rowData: AssetTableRow | undefined;

  getFileIcon(rowData: AssetTableRow | undefined): string {
    if (!rowData?.fileType) return 'pi pi-fw pi-folder-open';
    if (!rowData?.fileName) return 'pi pi-fw pi-file-o';

    const extension = rowData?.fileName.split('.').pop()?.toLowerCase();

    switch (extension) {
      case 'docx':
      case 'doc':
        return 'pi pi-fw pi-file-word';
      case 'pdf':
        return 'pi pi-fw pi-file-pdf';
      case 'json':
        return 'pi pi-fw pi-file';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'svg':
        return 'pi pi-fw pi-image';
      case 'resx':
      case 'xml':
        return 'pi pi-fw pi-file-o';
      default:
        return 'pi pi-fw pi-file-o';
    }
  }
}
